import { ConcreteEncodable } from "./ConcreteEncodable";

import { BMTimeCodeImplEncoder } from "../../encoder/BMTimeCodeImplEncoder";

import * as CubiqTS from "../../index";
import { BMTimeCode } from "../BMTimeCode";

export class BMTimeCodeImpl extends ConcreteEncodable implements BMTimeCode {
  public static enType: string = "com.bcdfx.model.BMTimeCodeImpl";

  /*FID=1*/
  public time: CubiqTS.moment.Moment | null = null;
  /*FID=2*/
  public code: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BMTimeCodeImplEncoder.Instance;
    this.setEncodableType(BMTimeCodeImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BMTimeCodeImpl[" +
      "time=" +
      this.time +
      "code=" +
      this.code +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
